


















import Vue from 'vue'
import { InputTextElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'InputTextEl',

  data: () => ({
    inputText: ''
  }),

  mounted () {
    this.inputText = this.templateItemData.value ?? ''
  },

  props: {
    templateItemData: {
      type: Object as () => InputTextElInterface,
      required: true
    }
  }
})
